/* <fb-swatches> - a design's colour versions as swatches.
   data-mode="card": hovering (mouse) or focusing a swatch shows that version on the card -
   its photo, its link, its colour name - and the choice stays. Clicking opens it. On a
   touch screen the first tap shows the version and the second tap opens it.
   data-mode="pdp": every swatch is a link to its version; hovering previews the colour name.
   Spec: docs/superpowers/specs/2026-10-14-nav-and-discovery-design.md */
(function () {
  if (customElements.get('fb-swatches')) return;

  class FbSwatches extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.mode || 'card';
      this.card = this.closest('[data-fb-card], .card-wrapper') || this.parentElement;
      this.label = this.card.querySelector('[data-fb-swatch-label]');
      this.swatches = Array.from(this.querySelectorAll('a.fb-sw'));
      var list = this.querySelector('.fb-swatches__list');
      if (list && list.scrollWidth <= list.clientWidth + 1) list.classList.add('is-short');
      this.resting = this.label ? this.label.textContent : '';

      this.swatches.forEach((sw) => {
        sw.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'touch') return;
          this.mode === 'card' ? this.select(sw) : this.say(sw.dataset.fbLabel);
        });
        sw.addEventListener('pointerleave', () => {
          if (this.mode === 'pdp') this.say(this.resting);
        });
        sw.addEventListener('focus', () => (this.mode === 'card' ? this.select(sw) : this.say(sw.dataset.fbLabel)));
        sw.addEventListener('blur', () => {
          if (this.mode === 'pdp') this.say(this.resting);
        });
        sw.addEventListener('click', (e) => {
          if (this.mode !== 'card') return;
          if (e.pointerType === 'touch' || this.lastPointer === 'touch') {
            if (sw.getAttribute('aria-current') !== 'true') {
              e.preventDefault();
              this.select(sw);
            }
          }
        });
        sw.addEventListener('pointerdown', (e) => {
          this.lastPointer = e.pointerType;
        });
      });
    }

    say(text) {
      if (this.label && text) this.label.textContent = text;
    }

    select(sw) {
      this.swatches.forEach((s) => {
        if (s === sw) s.setAttribute('aria-current', 'true');
        else s.removeAttribute('aria-current');
      });
      this.say(sw.dataset.fbLabel);
      var imgs = this.card.querySelectorAll('[data-fb-card-img], .card__media img');
      var img = imgs[0];
      if (img && sw.dataset.fbImg && img.getAttribute('src') !== sw.dataset.fbImg) {
        img.removeAttribute('srcset');
        img.setAttribute('src', sw.dataset.fbImg);
        if (sw.dataset.fbAlt) img.setAttribute('alt', sw.dataset.fbAlt);
      }
      // Dawn's card shows a second photo on hover: that version's own, or its first again
      if (imgs[1] && sw.dataset.fbImg) {
        imgs[1].removeAttribute('srcset');
        imgs[1].setAttribute('src', sw.dataset.fbImg2 || sw.dataset.fbImg);
      }
      var href = sw.getAttribute('href');
      this.card
        .querySelectorAll('[data-fb-card-link], .card__heading a, a.full-unstyled-link')
        .forEach((a) => a.setAttribute('href', href));
      // quick add opens the version shown, not the design's lead
      this.card.querySelectorAll('[data-product-url]').forEach((el) => el.setAttribute('data-product-url', href));
    }
  }
  customElements.define('fb-swatches', FbSwatches);
})();
